import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ChildUserAccountDto } from 'src/app/core/dtos/dto';
import { selectChildTermName } from 'src/app/state/my-account.selectors';

@Component({
  selector: 'app-product-business-account',
  templateUrl: './product-business-account.component.html',
  styleUrls: ['./product-business-account.component.scss']
})
export class ProductBusinessAccountComponent implements OnInit {
  @Input() childAccounts: ChildUserAccountDto[];
  @Input() canPurchase: boolean;
  @Output() add: EventEmitter<number[]> = new EventEmitter();
  @Output() continue = new EventEmitter();

  selectedChildAccountsIds: number[] = [];
  childAccountsForm: FormGroup;
  selectAllCheckbox = false;
  selectChildTermName$: Observable<string>;

  constructor(
    private fb: FormBuilder,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.selectChildTermName$ = this.store.pipe(select(selectChildTermName));
    this.childAccountsForm = this.fb.group({
      selectedChildAccounts: this.fb.array([])
    });
  }

  onSelect(event) {
    const childAccountsArray = this.childAccountsForm.controls.selectedChildAccounts.value;
    if (event.target.checked) {
      childAccountsArray.push(event.target.value);
    } else {
      const index = childAccountsArray.indexOf(event.target.value);
      childAccountsArray.splice(index, 1);
    }
    this.selectedChildAccountsIds = childAccountsArray;
  }

  toggleSelectAll(event) {
    if (event.target.checked) {
      this.selectedChildAccountsIds = this.childAccounts.map(x => x.userAccountId);
      this.selectAllCheckbox = true;
    } else {
      this.selectedChildAccountsIds = [];
      this.selectAllCheckbox = false;
    }
  }

  continueShopping() {
    this.continue.emit();
  }

  batchAddItem() {
    this.add.emit(this.selectedChildAccountsIds);
  }

}
